import { ICON_CHEVRON_RIGHT_WHITE, ICON_WARNING_FILL } from '@repo/assets';
import { QNA_TIME_LIMIT } from '@repo/constants';
import { useState } from 'react';
import styled from 'styled-components';

type Props = {
  lang: 'KOR' | 'ENG';
};

export const TimeLimit = ({ lang = 'ENG' }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper>
      <Button type='button' onClick={() => setIsOpen(!isOpen)}>
        <img src={ICON_WARNING_FILL} alt='' width={16} />
        <Title>{QNA_TIME_LIMIT[lang].title}</Title>
        <IconChevron
          src={ICON_CHEVRON_RIGHT_WHITE}
          alt=''
          width={20}
          isOpen={isOpen}
        />
      </Button>
      {isOpen && <Contents>{QNA_TIME_LIMIT[lang].contents}</Contents>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  width: 335px;
  border-radius: 0px 0px 8px 8px;
  padding: 10px 20px;
  background-color: #3a3b3e;
  opacity: 0.95;
  @media screen and (max-width: 520px) {
    left: 0;
    width: 100%;
  }
`;

const Button = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
`;

const Title = styled.span`
  margin: 0 auto 0 6px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
`;

const IconChevron = styled.img<{ isOpen: boolean }>`
  transform: rotate(90deg);
  transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
  transition: all 0.15s;
`;

const Contents = styled.p`
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  line-height: 135%;
`;
